import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {loadIAMGroups} from "./user-managementAPI";
import {LOADING, SUCCESS} from "../../httpClient";

const initialState = {
    iamGroups: [],
    iamGroupsStatus: 'idle'
}


const iam = "iam";

export const loadIAMGroupsAsync = createAsyncThunk(
    `${iam}/fetchIAMGroups`,
    async (token) => {
        return await loadIAMGroups(token);
    }
);

export const iamSlice = createSlice({
    name: iam,
    initialState,
    reducers: {
        loadGroups: (state, action) => {
            state.iamGroups = action.payload
        },
        clear: (state) => {
            state = initialState;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadIAMGroupsAsync.pending, (state) => {
                state.iamGroupsStatus = LOADING;
            })
            .addCase(loadIAMGroupsAsync.fulfilled, (state, action) => {
                state.iamGroupsStatus = SUCCESS;
                state.iamGroups = action.payload
            })
    }
});

export const { loadGroups, clear } = iamSlice.actions;
export default iamSlice.reducer;
